module.exports = __webpack_public_path__ + "static/fonts/Athiti-Medium.ttf.c3ba168.eot";